import Text from "./Text"
import Path from "./Path"
import Image from "./Image"
import Vector from "./Vector"
import Locked from "./Locked"
import Multiple from "./Multiple"
import Canvas from "./Canvas"

export default {
  StaticText: Text,
  StaticPath: Path,
  StaticImage: Image,
  StaticVector: Vector,
  Locked,
  Multiple,
  // Canvas,
}
